module.exports = __webpack_public_path__ + "img/credit-repair-icon.e6d4a8ae.svg";